<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useRuntimeStore } from '../stores/runtime'
import { openBackendBootstrap } from '../lib/sdk'

const route = useRoute()
const router = useRouter()
const store = useRuntimeStore()
const message = ref('Подключаем S-A-S Forms…')

onMounted(async () => {
  const ticket = String(route.query.ticket || '')
  try {
    if (!ticket) {
      if (await store.restore()) await router.replace('/')
      else await openBackendBootstrap()
      return
    }
    const result = await store.exchange(ticket)
    window.history.replaceState({}, document.title, '/entry')
    if (result.status === 'ready') {
      await router.replace('/')
    } else if (result.status === 'link_required') {
      await router.replace('/setup')
    } else {
      message.value = String(result.payload?.message || 'Не удалось открыть приложение')
      await router.replace(`/error?message=${encodeURIComponent(message.value)}`)
    }
  } catch (error) {
    message.value = error instanceof Error ? error.message : 'Ошибка запуска'
    await router.replace(`/error?message=${encodeURIComponent(message.value)}`)
  }
})
</script>

<template>
  <div class="center-card">
    <div class="loader" />
    <h1>S-A-S Forms</h1>
    <p>{{ message }}</p>
  </div>
</template>
